<template>
  <b-navbar fixed-top>
    <template #brand>
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <img src="../matrizimg/logo.png" alt="Generar la matriz de compatibilidad" width="20px" height="28" />
      </b-navbar-item>
    </template>

    <template #start>
      <b-navbar-item href="/">
        Inicio
      </b-navbar-item>

      <b-navbar-item>
        Documentación
      </b-navbar-item>

      <b-navbar-dropdown label="Mas">
        <b-navbar-item href="#">
          Acerca de ...
        </b-navbar-item>
        <b-navbar-item href="https://www.gestionhseq.com/#gcontacto">
          Contacto
        </b-navbar-item>
      </b-navbar-dropdown>
    </template>

    <template #end>
      <b-navbar-item tag="div">
        <div class="buttons">
          <a class="button is-primary">
            <strong>Registrame</strong>
          </a>
          <a class="button is-light">
            Ingresar
          </a>
        </div>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>
<script>
export default {
  name: 'navigationbar'
}
</script>
